import { CompanyGlobalFinancialMonitoringPartTwo } from '../components';
import { useCompanyGlobalFinancialMonitoringPartTwo } from '../hooks/useCompanyGlobalFinancialMonitoringPartTwo';
import { PageComponentProps } from '../types';

export const CompanyGlobalFinancialMonitoringPartTwoStep = ({
  canGoBack,
}: PageComponentProps) => {
  const { initialValues, onSubmit, submitLoading, goToBack } =
    useCompanyGlobalFinancialMonitoringPartTwo();

  return (
    <CompanyGlobalFinancialMonitoringPartTwo
      canGoBack={canGoBack}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
